import { useStore } from 'hooks/useStore';
import UnconstraintForecastView from './components/UnconstraintForecastView';
import { observer } from 'mobx-react';
import BulkUpdateModal from './components/BulkUpdate';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const UnconstraintForecast = () => {
  const {
    UnconstrainedForecastViewStore: {
      conceptSearchInput,
      conceptDetails,
      isConceptDetailsLoading,
      handleGetConceptDetails,
    },
  } = useStore();
  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get('search');

  useEffect(() => {
    if (searchValue) {
      handleGetConceptDetails(parseFloat(searchValue));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- initial load only
  }, []);

  return (
    <div>
      {conceptSearchInput.length <= 20 && !isConceptDetailsLoading && conceptDetails?.gfc === 0 ? (
        <div
          style={{
            width: '100vw',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: '2rem',
          }}
        >
          <h2>Search a concept to see Unconstrained Forecast</h2>
        </div>
      ) : (
        <UnconstraintForecastView />
      )}
      <BulkUpdateModal />
    </div>
  );
};

export default observer(UnconstraintForecast);
